import script from "./article.vue?vue&type=script&setup=true&lang=js"
export * from "./article.vue?vue&type=script&setup=true&lang=js"

import "./article.vue?vue&type=style&index=0&id=30e3e7a4&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e3e7a4"]])

export default __exports__